// The Deephaven API script isn't packaged as a module (yet), and is just included in index.html, exported to the global namespace
// This include file is simply a wrapper so that it behaves like a module, and can be mocked easily for unit tests

var dh = globalThis.dh;
export default dh;
//# sourceMappingURL=dh.js.map